import "./App.css";
import Home from "./components/Home";
import { Box } from "@chakra-ui/react";
import React from "react";

function App() {
  return (
    <Box>
      <Home />
    </Box>
  );
}

export default App;
